const KEY_MIXPANEL_TOKEN = "REACT_APP_MIXPANEL_TOKEN";
const KEY_SENTRY_DATA_SOURCE_NAME = "REACT_APP_SENTRY_DATA_SOURCE_NAME";
const KEY_SENTRY_ENVIRONMENT = "REACT_APP_SENTRY_ENVIRONMENT";
const KEY_STRIPE_PUBLISHABLE_KEY = "REACT_APP_STRIPE_PUBLISHABLE_KEY";
const KEY_SUPER_API_BASE_URL = "REACT_APP_SUPER_BASE_URL";

function fetchEnvVar(key: string): string {
  const val = fetchOptionalEnvVar(key);
  if (!val) {
    throw new Error(`missing environment variable: ${key}`);
  }

  return val;
}

function fetchOptionalEnvVar(key: string): string | undefined {
  return process.env[key];
}

const env = {
  base_urls: {
    fetch_for_super: (): string => {
      return fetchEnvVar(KEY_SUPER_API_BASE_URL);
    },
  },

  mixpanel: {
    fetch_token: (): string | undefined => {
      return fetchOptionalEnvVar(KEY_MIXPANEL_TOKEN);
    },
  },

  sentry: {
    fetch_data_source_name: (): string | undefined => {
      return fetchOptionalEnvVar(KEY_SENTRY_DATA_SOURCE_NAME);
    },

    fetch_environment: (): string | undefined => {
      return fetchOptionalEnvVar(KEY_SENTRY_ENVIRONMENT);
    },
  },

  stripe: {
    fetch_publishable_key: (): string => {
      return fetchEnvVar(KEY_STRIPE_PUBLISHABLE_KEY);
    },
  },
};

export default env;
